export const getTeleportToHubDelay = (enablePureGamecast = false) =>
  enablePureGamecast ? 9000 : 34000;
